/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { createRoute, Route } from 'framework/routing';
import { ProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import EmployeeFeedbacksList from './feedbackList';
import { FEEDBACKS_ABOUT_ME } from './EmployeeFeedbacksService';
import { WORKERS_PATH } from 'domain/shared/employee';

const FEEDBACKS_PATH = 'feedbacks';

const useFeedbacksRoute = () => {
  const { singleEntityRoute: employeeRoute } = createRoute({ listRoute: WORKERS_PATH });

  return createRoute({
    listRoute: `${employeeRoute}/${FEEDBACKS_PATH}`,
  });
};

const FeedbacksRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useFeedbacksRoute();

  return (
    <Routes>
      <Route
        path={listRoute}
        element={
          <ProtectedRoute permissionToCheck={FEEDBACKS_ABOUT_ME}>
            <EmployeeFeedbacksList />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

export default FeedbacksRouter;
